import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingStop, login } from 'redux/action';
import { toast } from 'react-toastify';
import { DashboardContainer, Table } from 'components';
import Body from './Body';
import API from 'services/api';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';

const Index = () => {
  const dispatch = useDispatch();
  const [searchInput, setSearchInput] = useState('');
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);

  const [filterType, setFilterType] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);

  const [locationList, setLocationList] = useState([]);
  const [franchiseList, setFranchiseList] = useState([]);

  useEffect(() => {
    loadLocationOptions();
  }, []);

  useEffect(() => {
    if (selectedOption !== null) {
      init();
    }
  }, [selectedOption]);

  useEffect(() => {
    if (searchInput == '') {
      setTableData(originalData);
    } else {
      const filteredResults = originalData.filter((data) =>
        Object.values(data).join(', ').toLowerCase().includes(searchInput.toLowerCase())
      );
      setTableData(filteredResults);
    }
  }, [searchInput]);

  const init = () => {
    let filter = '';

    if (filterType.value == 'franchise') {
      filter = 'franchise_id';
    } else if (filterType.value == 'location') {
      filter = 'location_id';
    }
    const data = { filterType: filter, filterValue: selectedOption?.value };
    dispatch(loadingStart());
    API.getMissingAuthorizationFormPatients(data)
      .then((response) => {
        if (response) {
          setTableData(response);
          setOriginalData(response);
        }
      })
      .finally(() => {
        dispatch(loadingStop());
      });
  };

  const loadLocationOptions = async () => {
    try {
      let response = await API.getFranchiseLocation();

      if (response && Array.isArray(response)) {
        // 💠 Extract unique franchises
        const franchiseMap = new Map();

        response.forEach((item) => {
          if (item.franchiseId && item.franchiseName) {
            franchiseMap.set(item.franchiseId, {
              label: item.franchiseName,
              value: item.franchiseId
            });
          }
        });

        const franchiseOptions = Array.from(franchiseMap.values());

        // 💠 Extract all locations (no grouping)
        const locationOptions = response
          .filter((item) => item.locationId && item.locationName)
          .map((item) => ({
            label: item.locationName,
            value: item.locationId
          }));

        // ✅ Set data in state
        setFranchiseList(franchiseOptions);
        setLocationList(locationOptions);

        // ✅ Default selections
        setFilterType({ label: 'Franchise', value: 'franchise' });

        // If "Health Services LLC" exists, set it; otherwise pick the first franchise
        const defaultFranchise =
          franchiseOptions.find((f) => f.label === 'Health Services LLC') ||
          franchiseOptions[0] ||
          null;

        if (defaultFranchise) {
          setSelectedOption(defaultFranchise);
        }
      }
    } catch (error) {
      console.error('Error loading franchise/location options:', error);
    }
  };

  // Handle filter type (Franchise or Location)
  const handleFilterTypeChange = (e) => {
    const selectedType = e;
    setFilterType(e);
    if (selectedType.value === 'franchise') {
      setSelectedOption(franchiseList[0]);
    } else {
      setSelectedOption(locationList[0]);
    }
  };

  // 🔹 Rename functionality (API + local update)
  const renameDocument = async (id, newTitle) => {
    try {
      dispatch(loadingStart());
      API.renameDocument({ document_id: id, document_title: newTitle })
        .then((response) => {
          if (response) {
            init();
          }
        })
        .finally(() => {
          dispatch(loadingStop());
        });
    } catch (error) {
      console.error('Rename failed:', error);
    }
  };

  return (
    <DashboardContainer>
      <Body
        _this={{
          tableData,
          searchInput,
          setSearchInput,
          filterType,
          setFilterType,
          selectedOption,
          setSelectedOption,
          handleFilterTypeChange,
          locationList,
          franchiseList,
          renameDocument
        }}
      />
    </DashboardContainer>
  );
};

export default Index;
